export enum ProjectionGroup {
  AHEAD = 'AHEAD',
  ON_TRACK = 'ON_TRACK',
  AT_RISK = 'AT_RISK',
  NOTSET = 'NO_SET',
  ALL = 'ALL',
  APPROACHING = 'APPROACHING',
}
